YP.PricingPro = function() {

    var slider           = $(".pagePricing-pro .slide_price");
    var bar_width        = $(".c-progressbar");
    var range            = $(".pagePricing-pro .contact_input");
    var activation       = $("#premium_step_1 .activation     .block_choice");
    var duration         = $("#premium_step_1 .duration       .block_choice");
    var bc_choice        = $("#premium_step_2 .information_bc .block_choice");
    var step_1           = $("#premium_step_1 .c-progress .step_1");
    var step_2           = $("#premium_step_2 .c-progress .step_2");
    var step_3           = $("#premium_step_3 .c-progress .step_3");

    return {
        init: function() {
            YP.PricingPro().barWidth();
            YP.PricingPro().stepActive();
            slider.on("click",             this.priceChange);
            range.on("input",              this.rangeChange);
            activation.on("click",  {  parent: activation }, this.selectInput);
            duration.on("click",    {  parent: duration   }, this.selectInput);
            bc_choice.on("click",   {  parent: bc_choice  }, this.selectInput);
        },
        priceChange: function(event){
            if($(slider).length > 0){
                if($(".price_offre").hasClass("year")){
                    $(".slide_price").removeClass("active");
                    $(".price_offre").removeClass("year");
                    $(".sub_price_offre").removeClass("year");
                }
                else{
                   $(".slide_price").addClass("active");
                    $(".price_offre").addClass("year");
                    $(".sub_price_offre").addClass("year");
                }
            }
        },
        barWidth: function(){
            if($(bar_width).length > 0){
                $(bar_width).each(function(){
                    var element     = $(this);
                    var nbr         = $(element).data('number');
                    var ttl         = $(element).data('total');
                    var width       = Math.min((nbr / ttl) * 100, 100);
                    var bar_color   = $(element).find('.c-progressbar__content');
                    bar_color.css('width',width+'%');
                    if (width < 99)         { bar_color.addClass('c-progressbar__content_color_green'); }
                    else                    { bar_color.addClass('c-progressbar__content_color_red'); }
                });

            }
        },
        rangeChange: function(event){
            if( ($(range).length > 0) ) {
                var text = "100";
                var offre = "0";
                var numberEmail ="500";
                var price ="10€";

                if( ($(this).val() == 0) || ($(this).val() == "0") ){
                    text = "100";
                    numberEmail ="500";
                    price ="10€";
                    offre = "0";
                }

                else if( ($(this).val() <= 1) || ($(this).val() == "1") ){
                    text = "500";
                    numberEmail ="2500";
                    price ="15€";
                    offre = "1";
                }

                else if( $(this).val() <= 2){
                    text = "1500";
                    numberEmail ="7500";
                    price ="20€";
                    offre = "2";
                }

                else if( $(this).val() <= 3){
                    text = "2500";
                    numberEmail ="12500";
                    price ="30€";
                    offre = "3";
                }
                else if( $(this).val() <= 4){
                    text = "5000";
                    numberEmail ="25000";
                    price ="50€";
                    offre = "4";
                }

                else{
                    text = "5000+";
                    numberEmail ="25000+";
                    price = "";
                    offre = "5";
                }

                $('.offre').removeClass("active");
                $('.offre.offre_'+offre).addClass("active");

                $('.number').text(text);
                $('.number_email').text(numberEmail);
                $('.price').text(price);

                var percent = Math.ceil(((this.value - this.min) / (this.max - this.min)) * 100);
                $(this).css('background', '-webkit-linear-gradient(left, #6E35F7 0%, #6E35F7 ' + percent + '%, white ' + percent + '%)');
            }
        },
        selectInput: function(event){
            var the_input = $(this).find('input');
            if(!$( the_input ).prop( "checked" )){

                $(event.data.parent).each(function( index ) {
                    $(this).removeClass('active');
                    var new_input = $(this).find('.selectInputMarker');
                    new_input.prop("checked", false);
                });

                $(this).addClass('active');
                the_input.prop("checked", true);
            }
        },
        stepActive: function(){
           if($(step_1).length > 0) {
                $(step_1).removeClass('c-progress-step--disabled');
           } 
           if($(step_2).length > 0) {
                $(step_2).removeClass('c-progress-step--disabled');
           }
           if($(step_3).length > 0) {
                $(step_3).removeClass('c-progress-step--disabled');
           }
        }
    }
}

window.addEventListener("load", function(){
    YP.PricingPro().init();
});
